import CopilotProvider from 'copilot-toolkit/CopilotProvider';
import { jsx as _jsx } from "react/jsx-runtime";
export default function MaybeCopilotWrapper({
  children,
  copilotEnabled
}) {
  if (copilotEnabled) {
    return /*#__PURE__*/_jsx(CopilotProvider, {
      children: children
    });
  }
  return children;
}